import { DataRoomShareableLink } from 'models/ShareableLink';

export type ShareableTable = Pick<
  DataRoomShareableLink,
  | 'name'
  | 'accessNumber'
  | 'fileIds'
  | 'lastAccessDate'
  | 'createdAt'
  | 'linkAccess'
  | 'linkExpiresDate'
  | 'totalAccessCount'
>;

export type ShareableTableKeys = Array<keyof ShareableTable>;

export const TABLE_COLUMNS: ShareableTableKeys = [
  'name',
  'accessNumber',
  'totalAccessCount',
  'fileIds',
  'lastAccessDate',
  'createdAt',
  'linkExpiresDate',
  'linkAccess',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  name: 'a-z',
  accessNumber: 'access',
  totalAccessCount: 'visitsUC',
  fileIds: 'files',
  lastAccessDate: 'lastAccess',
  createdAt: 'created',
  linkExpiresDate: 'expiresOn',
  linkAccess: '',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  name: 300,
  accessNumber: 360,
  lastAccessDate: 160,
  totalAccessCount: 80,
  createdAt: 120,
  linkExpiresDate: 120,
  fileIds: 80,
  linkAccess: 100,
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  name: 'sortName',
  lastAccessDate: 'lastAccessDate',
  totalAccessCount: 'totalAccessCount',
  createdAt: 'createdAt',
  linkExpiresDate: 'linkExpiresDate',
};
